import React, { useEffect, useState } from 'react';
import { ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import Logo from 'assets/images/logo.png';
import { ReactComponent as Toggle } from 'assets/icons/Filter.svg';
import { sidebarData } from './sidebar.data';
import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from 'assets/icons/Arrow-left.svg';
import Category from 'assets/icons/Category.svg';
import CategoryFill from 'assets/icons/Category-fill.svg';
import { Drawer } from 'antd';
import './sidebar.style.scss';
import ENV from 'env.json';
import { persianDigit } from 'scripts';

const Sidebar: React.FC<ConnectedProps<typeof connector> & { isCollapse: (e: boolean) => void }> = function (
    props: ConnectedProps<typeof connector> & { isCollapse: (e: boolean) => void },
) {
    const [state, setState] = useState('/');
    const location = useLocation();
    const [isCollapse, setIsCollapse] = useState(false);
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const [menuMobileActivate, setMenuMobileActivate] = useState(false);
    const mobileMenuItems = ['markets', 'verify', 'profile', 'referral'];

    useEffect(() => {
        setState(location.pathname);
        if (mobileMenuItems.includes(location.pathname)) setMenuMobileActivate(true);
        else setMenuMobileActivate(false);
    }, [location.pathname]);

    useEffect(() => {
        props.isCollapse(isCollapse);
    }, [isCollapse]);

    return (
        <>
            <div
                className={`hidden md:flex fixed transition-[max-width] flex-col ${isCollapse ? 'max-w-[96px]' : 'max-w-[248px]'} w-full h-screen border-l border-darkPurple-20`}
            >
                <div className="h-[70px] flex items-center py-4 px-6 border-b border-darkPurple-20 justify-center relative">
                    <Link
                        className={`w-[120px] origin-left transition-[scale] clickable h-10 ${isCollapse ? 'scale-0' : 'scale-100'}`}
                        to="/"
                    >
                        <img src={Logo} alt="30pay" />
                    </Link>
                    <span className="flex-1" />
                    <Toggle
                        onClick={() => setIsCollapse(!isCollapse)}
                        className={`min-w-6 h-6 clickable ${isCollapse ? 'absolute' : 'relative'}`}
                    />
                </div>
                <div
                    style={{ direction: 'ltr' }}
                    className="flex-1 w-full flex flex-col gap-2 p-6 overflow-y-auto overflow-x-hidden"
                >
                    {sidebarData.map((item, index) => (
                        <Link
                            style={{ direction: 'rtl' }}
                            to={`${item.key}`}
                            key={index}
                            className={`flex transition-[background-color] bg-white items-center cursor-pointer min-h-12 min-w-12 gap-3 hover:bg-[#F1F8FF] px-3 rounded-[30px] text-[#000000] ${state === item.key ? '!bg-primary-100 text-white' : ''}`}
                        >
                            {item.icon ? <img src={item.key === state ? item.iconFill : item.icon} /> : null}

                            <label
                                className={`cursor-pointer whitespace-nowrap origin-right ${isCollapse ? 'scale-0' : 'scale-100'}`}
                            >
                                {item.label}
                            </label>
                        </Link>
                    ))}
                </div>
                <Link
                    to={'/profile'}
                    className={`bg-primary-100 overflow-hidden mt-4 !transition-all clickable flex flex-col ${isCollapse ? 'max-w-[48px] p-3 max-h-[48px]' : 'max-w-[200px] p-4 max-h-[87px]'}  mx-auto w-full mb-4 rounded-lg gap-3 text-white`}
                >
                    <div className={`flex items-center gap-2 ${isCollapse ? 'max-h-[24px]' : ''}`}>
                        <div className="rounded-[4px] bg-warning-light min-w-6 min-h-6" />
                        <p
                            className={`transition-[scale] whitespace-nowrap origin-bottom text-sm font-bold ${isCollapse ? 'scale-0' : 'scale-100'}`}
                        >
                            {props.user?.level.title}
                        </p>
                        <img
                            className={`transition-[scale] origin-bottom w-6 h-6 ${isCollapse ? 'scale-0' : 'scale-100'}`}
                            src={ArrowLeft}
                            alt="verify"
                        />
                    </div>
                    <p
                        className={`transition-[scale] whitespace-nowrap origin-bottom font-medium text-xs ${isCollapse ? 'scale-0' : 'scale-100'}`}
                    >
                        برای افزایش سطح خود کلیک کنید
                    </p>
                </Link>
                <p className="w-full items-center justify-center text-center text-sm font-medium text-gray-500 pb-4">
                    نسخه {persianDigit(ENV.version)}
                </p>
            </div>
            <div className="md:hidden fixed z-50 bottom-0 w-full px-6 min-h-[64px] flex items-center bg-white border-t border-primary-20 justify-center">
                {sidebarData.map(
                    (item, index) =>
                        index < 4 && (
                            <Link
                                onClick={() => setMobileDrawerOpen(false)}
                                to={`${item.key}`}
                                className={` ${item.key === state && !mobileDrawerOpen ? 'flex-1 px-3 bg-primary-100' : 'flex-[0.7]'} flex-1  py-2 rounded-[20px] !transition-all z-10 flex items-center justify-center clickable gap-2`}
                                key={index}
                            >
                                {item.icon ?
                                    <img
                                        src={state === item.key && !mobileDrawerOpen ? item.iconFill : item.icon}
                                        alt="30pay"
                                    />
                                    : null
                                }
                                {state === item.key && !mobileDrawerOpen && (
                                    <label
                                        className={`!transition-all origin-r font-bold text-xs text-white whitespace-nowrap`}
                                    >
                                        {item.label}
                                    </label>
                                )}
                            </Link>
                        ),
                )}
                <div
                    onClick={() => {
                        setMobileDrawerOpen(true);
                    }}
                    className={` ${mobileDrawerOpen || menuMobileActivate ? 'flex-1 px-3 bg-primary-100' : 'flex-[0.7]'} flex-1  py-2 rounded-[20px] !transition-all z-10 flex items-center justify-center clickable gap-2`}
                >
                    <img src={mobileDrawerOpen || menuMobileActivate ? CategoryFill : Category} alt="30pay" />
                    {(mobileDrawerOpen || menuMobileActivate) && (
                        <label className={`!transition-all origin-r font-bold text-xs text-white whitespace-nowrap`}>
                            منو
                        </label>
                    )}
                </div>
                <Drawer
                    placement="bottom"
                    width={500}
                    closeIcon={false}
                    onClose={() => setMobileDrawerOpen(false)}
                    open={mobileDrawerOpen}
                >
                    {sidebarData.map(
                        (item, index) =>
                            index >= 4 && (
                                <Link
                                    onClick={() => setMobileDrawerOpen(false)}
                                    to={`${item.key}`}
                                    className={` ${item.key === state ? 'flex-1 bg-primary-100' : 'flex-[0.7]'} px-3 flex-1  py-2 rounded-[30px] !transition-all z-10 flex items-center clickable gap-2 h-12`}
                                    key={index}
                                >
                                    {item.icon ? <img src={state === item.key ? item.iconFill : item.icon} alt="30pay" /> : null}
                                    <label
                                        className={`!transition-all origin-r font-medium text-sm ${state === item.key ? 'text-white' : 'text-black-100'} whitespace-nowrap`}
                                    >
                                        {item.label}
                                    </label>
                                </Link>
                            ),
                    )}
                    <p className="w-full items-center justify-center text-center text-sm font-medium text-gray-500">
                        نسخه {persianDigit(ENV.version)}
                    </p>
                </Drawer>
            </div>
        </>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Sidebar);
